import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, Drawer, Button, Space } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faEdit, faEllipsis, faCloudDownload, faCloudArrowUp, faListCheck, faFileInvoice } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";

import { Link, useNavigate } from "react-router-dom";

import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  list,
} from "../../../controllers/V1/customerDue/dueController";
import { getPage } from "../../../controllers/common";

import AddEditDataPopUp from "./AddEditDataPopUp";
import ExportPopup from './Export';
import ImportPopup from "./Import"
import ImportCollection from "./ImportCollection";
import UpdateDueAmount from "./UpdateDueAmount";
import UpdateInvoiceName from "./UpdateInvoiceName";
import { usePermissions } from "../../../controllers/PermissionContext";
import { includes } from "lodash";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const navigation = useNavigate();
  const PERMISSION = usePermissions("customer_due");
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFilterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [isImportShow, setImportShow] = useState(false);
  const handleImportDrawer = () => setImportShow(!isImportShow);

  const [isImportCollectionShow, setImportCollectionShow] = useState(false);
  const handleImportCollection = () => setImportCollectionShow(!isImportCollectionShow);

  const [isDueAmountPopup, setDueAmountPopup] = useState(false);
  const handleDueAmountPopup = () => setDueAmountPopup(!isDueAmountPopup);

  const [isInvoiceNamePopup, setInvoiceNamePopup] = useState(false);
  const handleInvoiceNamePopup = () => setInvoiceNamePopup(!isInvoiceNamePopup);
  const [invoiceNameEditData, setInvoiceNameEditData] = useState('');

  const [addEditPopup, setAddEditPopup] = useState(false);
  const toggleAddEditPopup = () => setAddEditPopup(!addEditPopup);
  const [collectType, setCollectType] =useState('Collect');

  const [edit_data, setEditData] = useState('');

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");


  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(filter?.filter_by === 'users_name'?{users_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'last_name'?{last_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'store_name'?{store_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'users_type'?{ users_type : filter?.search }:null),
          ...(filter?.filter_by === 'users_mobile'?{users_mobile : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'pos_number'?{pos_number : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'due_amount'?{due_amount : parseFloat(filter?.search) }:null),
          ...(filter?.filter_by === 'bind_person_name'?{bind_person_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'bind_person_id'?{bind_person_id : filter?.search }:null),
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') || '',
        'from'      : form.get('from_date') || '',

      }))
      // console.log('filter',filter);
      // alert('submit');
      handleFilterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "U-Winn CRM || Customer's due list";
  }, [currentPage, showRequest, filter, addEditPopup, isDueAmountPopup, isInvoiceNamePopup]);

  useEffect(()=>{
    if(edit_data){
      setAddEditPopup(true);
    }
  },[edit_data]);

  const handleUserTypeChange = async (type='') => {
    try {
      setFilter((pre)=>({
        ...pre,
        'filter_by' : 'users_type',
        'search'    : type || ''
      }))
    } catch (error) {
      
    }
  }
  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Customer's due list"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        handleUserTypeChange("");
                        setShowRequest("");
                      }}
                    />
                    <Tab
                      label="BDM"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => handleUserTypeChange("BDM")}
                    />

                    <Tab
                      label="Manager"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => handleUserTypeChange("Manager")}
                    />

                    <Tab
                      label="Sales Supervisor"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => handleUserTypeChange("Sales Supervisor")}
                    />

                    <Tab
                      label="Sales Person"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => handleUserTypeChange("Sales Person")}
                    />

                    <Tab
                      label="Retailer"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => handleUserTypeChange("Retailer")}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div className="inventory_filter_div" onClick={handleFilterDrawer}>
                    <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filter
                    </Link>
                  </div>
                  {(PERMISSION?.export === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                    <div className="inventory_filter_div" onClick={handleExportDrawer}>
                      <FontAwesomeIcon icon={faCloudDownload} />
                      <Link
                        to={false}
                        className="filter_btn_invontry_rating_review"
                      >
                        Export
                      </Link>
                    </div>
                  )}
                  {(PERMISSION?.update_due === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                    <div className="inventory_filter_div" onClick={handleDueAmountPopup}>
                      <Link to={false} class="filter_btn_invontry_rating_review">
                        <FontAwesomeIcon icon={faCloudArrowUp} />
                        Update Due
                      </Link>
                    </div>
                  )}
                  {(PERMISSION?.update_collection === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                    <div className="inventory_filter_div" onClick={handleImportCollection}>
                      <Link to={false} class="filter_btn_invontry_rating_review">
                        <FontAwesomeIcon icon={faCloudArrowUp} />
                        Upload collection 
                      </Link>
                    </div>
                  )}

                  {/* <div onClick={() => toggleAddEditPopup()}>
                    <button type="button" class="btn btn-dark">
                      <span className="request_new_categories">Add New</span>
                    </button>
                  </div> */}
                </div>
              </div>
            </Box>            
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellSpacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Customer's Details</th>
                              <th>Type</th>
                              <th>POS Number</th>
                              <th>Bind With</th>
                              <th>A/C Details</th>
                              {/* <th>Target Collection Amt.</th>
                              <th>Total Collected Amt.</th>
                              <th>Target Settled Amt.</th>
                              <th>Total Settled Amt.</th> */}
                              <th>Due Amt.</th> 
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    <td>
                                      {["Manager", "Sales Supervisor","Sales Person"].includes(items?.users_type) && (
                                        items?.online_status === 'Online' ? '🟢' : '🔴'
                                      )}
                                      {SKIP + index + 1}</td>
                                    <td className="admin_user_list_date">
                                      {items?.store       && (<span>Store   : {items?.store_name}<br/></span>)} 
                                      {items?.users_name  && (<span>Name    : {items?.users_name} {items?.last_name}<br/></span>)} 
                                      {items?.users_email && (<span>Email   : {items?.users_email}<br/></span>)} 
                                      {items?.users_mobile && (<span>Mobile  : {items?.users_mobile}<br/></span>)}
                                      {items?.invoice_name && (<span>Invoice Name  : {items?.invoice_name}<br/></span>)}                                         
                                    </td>
                                    <td>{items?.users_type || '-'}</td>
                                    <td>{items?.pos_number || '-'}</td>
                                    <td className="admin_user_list_date">
                                      {items?.bind_person_name && (<span>{items?.bind_person_name}<br/></span>)}
                                      {items?.bind_user_type && (<span>Type : {items?.bind_user_type}<br/></span>)}
                                    </td>
                                    <td className="admin_user_list_date" style={{textAlign : "left"}}>
                                      Target Collection : {items?.target_collection || 0} <br/>
                                      Total Collected : {items?.total_collection || 0} <br/>
                                      Target Settled : {items?.target_settlement || 0} <br/>
                                      Total Settled : {items?.total_settlement || 0} <br/>
                                      Wifi Incentive : {items?.wifi_incentive || 0} <br/>
                                    </td>
                                    <td className="admin_user_list_date" style={{textAlign : "left"}}>
                                      Old Due : {items?.old_due_amount || 0} <br/>
                                      Total Due : {items?.due_amount || 0} 
                                    </td>

                                    <td className="admin_user_list_date">
                                      { items?.status === 'A' && 'Active' }
                                      { items?.status === 'I' && 'Inactive' }
                                      { items?.status === 'D' && 'Delete' }
                                      { items?.status === 'B' && 'Block' }
                                    </td>
                                    {/* <td className="admin_user_list_date">{moment(items?.createdAt).format('DD-MM-YYY h:mm A')}</td> */}
                                    {/* <td className="admin_user_list_date">{moment(items?.updatedAt).format('DD-MM-YYY h:mm A')}</td> */}
                                    <td>
                                      <Dropdown
                                        overlay={
                                          <Menu>
                                             {(PERMISSION?.collect === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                                              <Menu.Item key={`01`} onClick={() => { setEditData(items); setCollectType('Collect') }} >
                                                <FontAwesomeIcon icon={faEdit} /> <span className="show_span">Collect</span>
                                              </Menu.Item>
                                             )}
                                            {(PERMISSION?.settle === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                                              <Menu.Item key={`02`} onClick={() => { setCollectType('Settle'); setEditData(items) }} >
                                                <FontAwesomeIcon icon={faEdit} /> <span className="show_span">Settle</span>
                                              </Menu.Item>
                                            )}
                                            {(PERMISSION?.collect === 'Y' || PERMISSION?.settle === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                                              <Menu.Item key={`03`} onClick={() => { setInvoiceNameEditData(items); setInvoiceNamePopup(true) }} >
                                                <FontAwesomeIcon icon={faFileInvoice} /> <span className="show_span">Update Invoice Name</span>
                                              </Menu.Item>
                                            )}
                                            {["Manager", "Sales Supervisor", "Sales Person"].includes(items?.users_type) && (
                                              <Menu.Item key={`04`} onClick={() => navigation("/customers/attendance", { state: items }) } >
                                                <FontAwesomeIcon icon={faListCheck} /> <span className="show_span">Atttendance</span>
                                              </Menu.Item>
                                            )}
                                          </Menu>
                                        }
                                        placement="bottomLeft"
                                        arrow
                                      >
                                        <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={10} /> : <tr> 
                                <td colspan="9" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      {/* Add/Edit Pop-Up */}
      <AddEditDataPopUp popUpOpen={addEditPopup} togglePopUp={toggleAddEditPopup} edit_data={edit_data} setEditData={setEditData} type={collectType} />
      {/* Export*/}
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} />
      <ImportPopup popUpOpen={isImportShow} togglePopUp={handleImportDrawer} />
      <ImportCollection popUpOpen={isImportCollectionShow} togglePopUp={handleImportCollection} />

      <UpdateDueAmount popUpOpen={isDueAmountPopup} togglePopUp={handleDueAmountPopup} />
      <UpdateInvoiceName popUpOpen={isInvoiceNamePopup} togglePopUp={handleInvoiceNamePopup} edit_data={invoiceNameEditData} setEditData={setInvoiceNameEditData} />
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFilterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFilterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'red', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='users_name' selected={filter?.filter_by ==='users_name'?true:false}>First Name</option>
                  <option value='last_name' selected={filter?.filter_by ==='last_name'?true:false}>Last Name</option>
                  <option value='store_name' selected={filter?.filter_by ==='store_name'?true:false}>Store name</option>
                  <option value='users_type' selected={filter?.filter_by ==='users_type'?true:false}>User Type</option>
                  <option value='users_mobile' selected={filter?.filter_by ==='users_mobile'?true:false}>Mobile</option>
                  <option value='pos_number' selected={filter?.filter_by ==='pos_number'?true:false}>POS Number</option>
                  <option value='due_amount' selected={filter?.filter_by ==='due_amount'?true:false}>Due Amount</option>
                  <option value='bind_person_name' selected={filter?.filter_by ==='bind_person_name'?true:false}>Bind with user's name</option>
                  <option value='bind_person_id' selected={filter?.filter_by ==='bind_person_id'?true:false}>Bind with user's id</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "black", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
